import { TextField } from '@mui/material';

interface VdbEndpointFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function VdbEndpointField({
  value,
  error,
  setValue,
}: VdbEndpointFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='Vector DB Endpoint'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default VdbEndpointField;

